module.exports = __webpack_public_path__ + "img/ic-epc-grey.2f06fa6d.svg";